import {Component, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {CommonConstants, ImagePathConstants, RoutesConstants} from '@coreconstant';

@Component({
    selector: 'app-page-removed-temporary',
    imports: [RouterModule],
    templateUrl: './page-removed-temporary.component.html',
    styleUrl: './page-removed-temporary.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class PageRemovedTemporaryComponent {
    commonConstants = CommonConstants
    routesConstants = RoutesConstants
    imagePathConstants = ImagePathConstants
    redirectMessage: string;
    redirectUrl = this.routesConstants.HOME;
    pageType: string;
    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
    ) {
        this._activatedRoute.queryParams.subscribe(params => {
            this.pageType = params['pageType'];
            // Same switch logic
        });
    }

    /**
     * Initializes the component and its dependent processes.
     */
    ngOnInit(): void {
        switch (this.pageType) {
            case 'venue':
                this.redirectMessage = "This venue is temporarily inactive";
                this.redirectUrl = this.routesConstants.VENUE_NAVIGATION;
                break;
            case 'vendor':
                this.redirectMessage = "This vendor is temporarily inactive";
                this.redirectUrl = this.routesConstants.VENDOR_NAVIGATION;
                break;
            case 'blog':
                this.redirectMessage = "This blog is temporarily inactive";
                this.redirectUrl = this.routesConstants.WEDSPIRATION;
                break;
            default:
                this.redirectMessage = "This page is temporarily inactive";
                this.redirectUrl = this.routesConstants.HOME;
                break;
        }
    }

}
